import { render } from "./TuscfdisAiChat.vue?vue&type=template&id=7b03e4c9&scoped=true"
import script from "./TuscfdisAiChat.vue?vue&type=script&lang=js"
export * from "./TuscfdisAiChat.vue?vue&type=script&lang=js"

import "./TuscfdisAiChat.vue?vue&type=style&index=0&id=7b03e4c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b03e4c9"]])

export default __exports__